import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MenuOptionsService } from '../menu-options.service';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.css']
})
export class ReleaseNotesComponent implements OnInit, OnChanges {

  @Input() release_notes_show;

  releaseNotes = [];

  constructor(private menu_options_service: MenuOptionsService) { }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && this.release_notes_show) {
      this.menu_options_service.get_release_notes().subscribe((data: any) => {
        this.releaseNotes = data;
        console.log(data)
      });
    }
  }

  getSeverity(type: string): string {
    switch (type) {
      case 'NEW': return 'success';
      case 'IMPROVEMENT': return 'info';
      case 'FIX': return 'warning';
      default: return 'secondary';
    }
  }

  openLink(url: string): void {
    window.open(url, '_blank'); // Opens in a new tab
  }

}
